import { NavLink } from "react-router-dom";
import { useState } from "react";

function Navbar() {
    const [menuOpen, setMenuOpen] = useState(false);

    return (
        <header className="navbar">
            <div className="container navbar-inner">
                <div className="logo"><a href='https://oxfordexports.in/' className="defaultColor">Oxford Exports</a></div>

                <nav className={`nav-links ${menuOpen ? "open" : ""}`}>
                    <NavLink to="/" end onClick={() => setMenuOpen(false)}>
                        Home
                    </NavLink>
                    <NavLink to="/aboutus" end onClick={() => setMenuOpen(false)}>
                        About
                    </NavLink>
                    <NavLink to="/product" onClick={() => setMenuOpen(false)}>
                        Product
                    </NavLink>
                    <NavLink to="/contact" onClick={() => setMenuOpen(false)}>
                        Contact
                    </NavLink>
                </nav>

                <button
                    className="menu-toggle"
                    onClick={() => setMenuOpen(!menuOpen)}
                >
                    ☰
                </button>
            </div>
        </header>
    );
}

export default Navbar;
